import { View } from 'es6/components/view'
import { getTemplate } from 'helpers/template-helper'
import { Popup } from 'es6/libs/popup'
import Backbone from 'init/backbone'
import { Defaults } from 'es-decorators'

/**
 * Модальное окно с сообщением об удаленном подарке.
 */

@Defaults({
  el: '#deleted-gift-popup',
  additionalOptions: ['fader'],
  events: {
    'click .js-popup-close': 'closePopup',
  },
})
export class DeletedGiftPopupView extends View {
  /**
   * @inheritDoc
   */
  run () {
    this.initPopup()
    this.template = getTemplate('#deleted-gift-popup-template')
    this.listenTo(Backbone, 'gift-deleted-from-cart', this.openPopup)
  }

  /**
   * Инициализация попапа.
   */
  initPopup () {
    this.popup = new Popup(this.$el)
    if (this.fader) {
      this.popup.addEventListener(Popup.EventType.BEFORE_OPEN, this.beforeOpen.bind(this))
      this.popup.addEventListener(Popup.EventType.BEFORE_CLOSE, this.beforeClose.bind(this))
    }
  }

  /**
   * Выполняется перед открытием попапа.
   */
  beforeOpen () {
    this.fader.show()
  }

  /**
   * Выполняется перед закрытием попапа.
   */
  beforeClose () {
    this.fader.hide()
  }

  /**
   * Открывает попап.
   * @param {Object} data Данные попапа.
   */
  openPopup (data) {
    const { message, link } = data || {}
    const { label: linkLabel, url: linkUrl } = link || {}
    if (message && linkLabel && linkUrl && this.popup.isClosed()) {
      this.$el.html(this.template({ message, linkLabel, linkUrl }))
      this.popup.open()
    }
  }

  /**
   * Закрывает попап.
   */
  closePopup () {
    this.popup.close()
  }
}
